import { navHeaderComponent } from './app-nav-header.component';
import { navFooterComponent } from './app-nav-footer.component';
import bootstrapDropdown from 'angular-ui-bootstrap/src/dropdown';
import './app-nav.scss';

export const appNav = angular
	.module('common.app-nav', [
        bootstrapDropdown
    ])
	.component('appHeader', navHeaderComponent)
	.component('appFooter', navFooterComponent)
	.name;


// WEBPACK FOOTER //
// ./src/app/common/app-nav/app-nav.module.js